import directives from './module';
import {PlayerSvc} from '../services/PlayerSvc';

interface Scope extends ng.IScope {
    $ctrl?: {
        player?: ng.IPromise<Player>;
    };
}

directives.directive('pauseHiddenPlayer', ($compile: ng.ICompileService,
                                           $rootScope: ng.IRootScopeService,
                                           PlayerSvc: PlayerSvc) => {
        return {
            restrict: 'A',
            scope: false,
            link(scope: Scope, element: ng.IAugmentedJQuery, attrs: any) {
                element.attr('is-on-screen', '');

                element.removeAttr('pause-hidden-player');

                $compile(element)(scope);

                const safePause = (player: Player) => {
                    if (player.isPlaying()) {
                        player.pause();
                    }
                };
                const safePlay = (player: Player) => {
                    if (!player.isPlaying()) {
                        player.play(Math.max(0, player.getTime()));
                    }
                };
                const findPlayer = (callback: Function) => {
                    const player = PlayerSvc.getPlayer(element[0].id);
                    return player && callback(player);
                };

                scope.$watch(attrs['pauseHiddenPlayer'], should => {
                    findPlayer(should ? safePlay : safePause);
                });

                $rootScope.$on('notOnScreen:' + attrs.id, () => findPlayer(safePause));
                $rootScope.$on('onScreen:' + attrs.id, () => findPlayer(safePlay));

                if (scope.$ctrl && scope.$ctrl.player) {
                    scope.$ctrl.player.then(p => {
                        if (element[0].classList.contains('on-screen')) {
                            p && p.play();
                        }
                    });
                }
            }
        };
    }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/pauseHiddenPlayer.ts